import React from "react";
import { formatDateFull, getInitials } from "../utils";

const ChatConversationItem = (props) => {
  const { data, fullName, image } = props || {};

  return (
    <li
      className={`chat-list ${data.senderType == "ACCOUNT" ? "left" : "right"}`}
    >
      <div className="conversation-list">
        <div className="conversation-list-content-image">
          {data?.senderType == "ACCOUNT" &&
            (image ? (
              <img src={image} className="img-fluid" />
            ) : (
              <div className="chat-center-content-header-initials">
                {getInitials(fullName)}
              </div>
            ))}
        </div>
        <div className="conversation-list-content-main-holder">
          {data.senderType == "ADMINISTRATOR" && (
            <div className="conversation-list-content-name">Admin</div>
          )}
          <div className="conversation-list-content">
            {data?.file && (
              <div className="conversation-list-content-image-detail">
                <img src={data?.file} className="img-fluid" alt={"LG"} />
              </div>
            )}
            <div className="conversation-list-content-text">
              {data?.message}
            </div>
          </div>

          <div className="conversation-list-content-time">
            {formatDateFull(data?.createdAt)}
          </div>
        </div>
      </div>
    </li>
  );
};

export default ChatConversationItem;
